<template>
  <div class="fullscreen-modal" v-if="visible">
    <div class="modal-wrapper">
      <!-- Header -->
      <div class="modal-header-custom">
        <span class="title">Volumes</span>
        <button type="button" class="btn-close-custom" @click="close">
          <i class="bx bx-x"></i>
        </button>
      </div>

      <!-- Participant Card -->
      <div class="participant-card" v-if="participant">
        <div class="avatar">
          <span class="initials">{{ getInitials(participant.name) }}</span>
        </div>
        <div class="info">
          <span class="name">{{ participant.name }}</span>
        </div>
        <div class="items-badge">
          <i class="bx bx-package"></i>
          <span>{{ storedCount }} Items</span>
        </div>
      </div>

      <!-- Items List -->
      <div class="items-list">
        <div
          v-for="item in items"
          :key="item.id"
          class="item-card"
          :class="{ 'is-returned': item.status === 'returned' }"
          @click="item.status === 'stored' ? returnItem(item) : null"
        >
          <div class="item-photo">
            <img v-if="item.photo_url" :src="item.photo_url" alt="Foto" />
            <div v-else class="no-photo">
              <i class="bx bx-image"></i>
            </div>
            <div class="status-badge" :class="item.status === 'stored' ? 'stored' : 'returned'">
              <i :class="item.status === 'stored' ? 'bx bx-check' : 'bx bx-time'"></i>
            </div>
          </div>
          <div class="item-details">
            <span class="type-name">{{ item.type_name || 'Item' }}</span>
            <div class="code">
              <i class="bx bx-grid-alt"></i>
              <span>{{ item.code }}</span>
            </div>
            <div class="location">
              <i class="bx bx-map"></i>
              <span>{{ item.location ? item.location.name : '--' }}</span>
            </div>
            <div class="dates">
              <div class="date-item" v-if="item.status === 'stored'">
                <span class="label">Entrada</span>
                <span class="value">{{ formatDate(item.stored_at) }}</span>
              </div>
              <template v-else>
                <div class="date-item">
                  <span class="label">Check-in</span>
                  <span class="value">{{ formatDate(item.stored_at) }}</span>
                </div>
                <div class="date-item">
                  <span class="label">Check-out</span>
                  <span class="value">{{ formatDate(item.returned_at) }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>

        <div v-if="items.length === 0" class="empty-state">
          <i class="bx bx-package"></i>
          <p>Nenhum volume registrado</p>
        </div>
      </div>

      <!-- Footer Button -->
      <div class="modal-footer-custom">
        <button type="button" class="btn-add-volume" @click="registerItem">
          <i class="bx bx-plus"></i>
          Adicionar volume
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'volumes-modal',
  props: {
    participant: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      default: function () { return [] }
    }
  },
  data: function () {
    return {
      visible: false
    }
  },
  computed: {
    storedCount: function () {
      return this.items.filter(function (i) { return i.status === 'stored' }).length
    }
  },
  methods: {
    getInitials: function (name) {
      if (!name) return '?'
      var parts = name.split(' ')
      if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase()
      }
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
    },
    formatDate: function (dateStr) {
      if (!dateStr) return '--'
      var date = new Date(dateStr)
      var options = { month: 'short', day: 'numeric' }
      var datePart = date.toLocaleDateString('en-US', options)
      var h = String(date.getHours()).padStart(2, '0')
      var min = String(date.getMinutes()).padStart(2, '0')
      return datePart + ', ' + h + ':' + min
    },
    open: function () {
      this.visible = true
      document.body.style.overflow = 'hidden'
    },
    close: function () {
      this.visible = false
      document.body.style.overflow = ''
      this.$emit('close')
    },
    registerItem: function () {
      this.$emit('register-item')
    },
    returnItem: function (item) {
      this.$emit('return-item', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.fullscreen-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 1050;
  display: flex;
  flex-direction: column;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 500px;
  margin: 0 auto;
  width: 100%;
}

.modal-header-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .btn-close-custom {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    padding: 0;
    line-height: 1;

    &:hover {
      color: #333;
    }
  }
}

.participant-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #556ee6;
  margin: 12px;
  border-radius: 10px;
  flex-shrink: 0;

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid rgba(255, 255, 255, 0.3);
    flex-shrink: 0;

    .initials {
      color: #fff;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;

    .name {
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .items-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.2);
    padding: 5px 10px;
    border-radius: 6px;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    flex-shrink: 0;

    i {
      font-size: 14px;
    }
  }
}

.items-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px;
}

.item-card {
  display: flex;
  gap: 10px;
  padding: 10px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(.is-returned) {
    border-color: #556ee6;
    box-shadow: 0 2px 8px rgba(85, 110, 230, 0.15);
  }

  &.is-returned {
    opacity: 0.7;
    cursor: default;
  }

  .item-photo {
    position: relative;
    width: 56px;
    height: 56px;
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .no-photo {
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 22px;
        color: #ccc;
      }
    }

    .status-badge {
      position: absolute;
      top: -3px;
      right: -3px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #fff;

      &.stored {
        background: #34c38f;
        color: #fff;
      }

      &.returned {
        background: #74788d;
        color: #fff;
      }

      i {
        font-size: 10px;
      }
    }
  }

  .item-details {
    flex: 1;
    min-width: 0;

    .type-name {
      font-size: 13px;
      font-weight: 600;
      color: #1a1a1a;
      display: block;
      margin-bottom: 2px;
    }

    .code, .location {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 11px;
      color: #666;
      margin-bottom: 1px;

      i {
        font-size: 12px;
        color: #999;
      }
    }

    .dates {
      display: flex;
      gap: 12px;
      margin-top: 4px;

      .date-item {
        .label {
          display: block;
          font-size: 9px;
          color: #999;
        }

        .value {
          font-size: 10px;
          color: #1a1a1a;
          font-weight: 500;
        }
      }
    }
  }
}

.empty-state {
  text-align: center;
  padding: 30px 20px;
  color: #999;

  i {
    font-size: 40px;
    display: block;
    margin-bottom: 8px;
  }

  p {
    margin: 0;
    font-size: 13px;
  }
}

.modal-footer-custom {
  padding: 12px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;

  .btn-add-volume {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    background: #556ee6;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: #4a5fd4;
    }

    i {
      font-size: 18px;
    }
  }
}
</style>
